<template>
  <main class="login-page">
    <LanguageChoice />

    <div class="container">
      <div v-if="tokenStatus != 'Expired'"
           class="form"
      >
        <form action="#"
              class="login-form"
              @submit.prevent="handleSignUpSubmit"
        >
          <input type="text"
                 name="email"
                 :placeholder="$t('register.email')"
                 class="readOnly"
                 :value="email"
                 readonly
          >
          <input v-model="password"
                 type="password"
                 name="password"
                 :placeholder="$t('register.password')"
          >
          <input v-model="repeatPass"
                 type="password"
                 name="password"
                 :placeholder="$t('register.repeatPassword')"
          >
          <button type="submit"
                  class="btn"
          >
            {{ resetPage ? $t("register.changePassword") : $t("register.signUp") }}
          </button>
          <button type="submit"
                  class="btn btnSU"
                  @click="handleSignUp"
          >
            {{ $t("register.backToLogin") }}
          </button>
        </form>
      </div>
    </div>
  </main>
</template>

<script setup>
import LanguageChoice from "../components/LanguageChoice.vue";
import { onMounted, ref, reactive } from "vue";
import { useToast } from "vue-toastification";
import router from "@/router";
import { API_Register } from "./../apiCalls/api";
import i18n from '../locales/i18n'
const toast = useToast();

//refs == single value
//const type = ref('SignIn');
const password = ref("");
const repeatPass = ref("");
const email = ref("");
const tokenStatus = ref("");

const resetPage = ref(false);

//reactive == object/list
const postObject = reactive({});

onMounted(async () => {
  if (window.location.href.indexOf("/reset") > -1) resetPage.value = true;

  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  email.value = urlParams.get("em");
  //så ska den se ut egentligen.
  if (urlParams.has("at") && urlParams.has("em")) {
    postObject["Email"] = urlParams.get("em");
    postObject["Token"] = urlParams.get("at");
  } else {
    console.log("s");
    tokenStatus.value = "Expired";
    router.push("/");
    toast.error(i18n.global.t("register.expiredCode"));
  }
});

function handleSignUp() {
  router.push("/");
}

async function handleSignUpSubmit() {
  if (tokenStatus.value == "Expired") {
    toast.error(i18n.global.t("register.expiredCode"));
  } else {
    if (password.value.length < 8 || repeatPass.value.length < 8) {
      //console.log(password.value);
      //console.log(repeatPass.value);
      toast.warning(i18n.global.t("register.passwordLength"));
      return;
    }

    if (password.value == repeatPass.value) {
      postObject["NewPassword"] = password.value;
      //console.log(postObject);
      try{
        const UserRegisterationRes = await API_Register(postObject);
        console.log(UserRegisterationRes)
        if (UserRegisterationRes.status == 200) {
          toast.success(
            resetPage.value
              ? i18n.global.t("register.userPasswordChanged")
              : i18n.global.t("register.userCreated")
          );
          window.setTimeout(function () {
            router.push("/");
          }, 1000);
        } else {
          toast.error(
            i18n.global.t("register.somethingWrong") +
              "\r\n\r\n" +
              UserRegisterationRes.data.message
          );
        }
      }
      catch(e){
        console.log(e)
        try{
          toast.warning(i18n.global.t("loginPage.resetPasswordTokenFailed")+"\r\n\r\nError: " +e.response.data.Message);
        }
        catch(e){
          toast.warning(i18n.global.t("loginPage.resetPasswordTokenFailed"));
        }
      }
    } else {
      toast.warning(i18n.global.t("register.passwordMatchFail"));
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/buttons.scss";
@import "../scss/input.scss";

@mixin message($fontcolor: #90a4ae) {
  color: $fontcolor;
  text-align: center;
  font-size: 14px;
}

.passGuide {
  font-size: 9px;
  margin-bottom: 5px;
}
.login-page {
  height: 100vh;
  overflow-y: scroll;
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
}

.container {
  padding: 8% 0 0;
  width: 365px;
  margin: auto;
}

.form {
  position: relative;
  z-index: 1;
  max-width: 350px;
  margin: 0 auto 100px;
  padding: 45px;
  background: #ffffff;
  border-radius: 20px;
}
.btnSU {
  margin-top: 10px;
}
.form {
  input {
    @include input100percent;
  }

  .btn {
    @include btn100percent;
  }

  .message {
    @include message;

    a {
      text-decoration: none;
      color: #00bfa5;
    }
  }
}

.form .register-form {
  display: none;
}

@media (max-width: 768px) {
  .container {
    padding: 8% 0 0;
    width: 265px;
    margin: auto;
  }

  .form {
    position: relative;
    z-index: 1;
    max-width: 250px;
    margin: 0 auto 100px;
    padding: 25px;
    background: #ffffff;
    border-radius: 20px;
  }
}
</style>
